import React, { useEffect, useState } from "react";
import { Box, Button, Drawer, Typography } from "@mui/material";
import right_arrow_icon from "../../../assets/images/subscription/right_arrow_icon.svg";
import UpdateBillingAddress from "./UpdateBillingAddress";
import { useDispatch } from "react-redux";
import { getBillingAddress } from "../../../appStore/actions/Subscription/action";
import { MANAGE_SUBSCRIPTION_DATA } from "../../../appStore/actions/Subscription/type";
import CancelSubscription from "./CancelSubscription";
import AddManageSinglePlanMember from "../Subscription/AddManageSinglePlanMember";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import { useTranslation } from "react-i18next";
import { subscriptionPlanType } from "../../../utils/constant";

const ManageSubscriptionHome = ({
  setToggelManageMemberDrawerOpen,
  setActiveButton,
  setAlertOpen,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [isManageBillingAddressOpen, setBillingAddressOpen] = useState(false);
  const [isCheckboxManageMemberDrawerOpen, setCheckboxManageMemberDrawerOpen] =
    useState(false);
  const [isCancleSubscriptionOpen, setCancleSubscriptionOpen] = useState(false);
  const dispatch = useDispatch();
  const { subscriptionDetails, allPlansList } = useAppSelectors();

  const handleOpenManageMemeberDrawer = () => {
    const purchasedPlans = allPlansList?.plans?.filter(
      (plan) => plan.purchased === true
    );
    if (
      subscriptionDetails?.length > 0 &&
      subscriptionDetails[0]?.planInfo?.gateway === 2
    ) {
      setAlertOpen(true);
    } else {
      if (purchasedPlans.length > 1) {
        setToggelManageMemberDrawerOpen(true);
      } else {
        setCheckboxManageMemberDrawerOpen(true);
      }
    }
  };

  const handleCancleClick = (data) => {
    if (data?.planInfo?.gateway === 2) {
      setAlertOpen(true);
    } else {
      dispatch({
        type: MANAGE_SUBSCRIPTION_DATA,
        payload: data,
      });
      setCancleSubscriptionOpen(true);
    }
  };

  useEffect(() => {
    dispatch(getBillingAddress());
  }, []);

  return (
    <>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isManageBillingAddressOpen}
        anchor={"right"}
      >
        <UpdateBillingAddress setBillingAddressOpen={setBillingAddressOpen} />
      </Drawer>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isCancleSubscriptionOpen}
        anchor={"right"}
      >
        <CancelSubscription
          setCancleSubscriptionOpen={setCancleSubscriptionOpen}
        />
      </Drawer>

      <Drawer
        sx={{ zIndex: 1202 }}
        open={isCheckboxManageMemberDrawerOpen}
        anchor={"right"}
      >
        <AddManageSinglePlanMember
          setCheckboxManageMemberDrawerOpen={setCheckboxManageMemberDrawerOpen}
          drawerType={"manage"}
        />
      </Drawer>
      <Box
        overflow={"scroll"}
        height={"calc(100vh - 8rem)"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "1px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#F9F8F8",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "grey",
          },
          // "@media (max-width: 1194px)": {
          //   height: "calc(100vh - 20rem)",
          // },
        }}
      >
        <Box width={"95%"}>
          {subscriptionDetails?.length > 0 &&
            subscriptionDetails?.map((item, i) => (
              <Box
                borderRadius={"2px"}
                bgcolor={"#F3F3F3"}
                padding={"0.5rem 0rem"}
                boxShadow="0px 1px 4px 0px #00000040"
                mb={"0.8rem"}
                key={i + "subscription"}
              >
                <Box width={"90%"} margin={"auto"} textAlign={"center"}>
                  <Typography
                    variant="h6"
                    fontSize={"1rem"}
                    color={"#183243"}
                    fontWeight={600}
                  >
                    {item?.name}
                  </Typography>
                  <Box mt={"0.5rem"}>
                    {item?.planType !== 0 && (
                      <Typography
                        fontWeight={600}
                        variant="caption"
                        fontSize={"1rem"}
                      >
                        {item?.symbol} {item?.price}
                      </Typography>
                    )}

                    <Typography variant="caption" display={"block"}>
                      {/* for {item?.quantity} person/month */}
                    </Typography>
                    <Typography
                      fontWeight={600}
                      variant="caption"
                      fontSize={"0.8rem"}
                      display={"block"}
                    >
                      {appContent?.KEY224} : {item?.billingCycle}
                    </Typography>
                  </Box>
                </Box>
                {/* planType = 0 freeTrails, 1 monthly , 2 yearly  */}
                {item?.planType !== 0 && (
                  <Box
                    width={"90%"}
                    margin={"auto"}
                    textAlign={"center"}
                    mt={"0.5rem"}
                  >
                    <Box
                      display={"flex"}
                      gap={"0.4rem"}
                      justifyContent={"center"}
                    >
                      <Button
                        onClick={() => handleCancleClick(item)}
                        disabled={item?.isCancelled}
                        sx={{
                          backgroundColor: "transparent",
                          color: "#183243",
                          padding: "0.2rem 0.4rem",
                          textTransform: "none",
                          borderRadius: "0.15rem",
                          border: "1px solid #DB0011",
                          ":hover": {
                            backgroundColor: "transparent",
                            color: "#183243",
                          },
                        }}
                        variant="contained"
                      >
                        {item?.isCancelled
                          ? appContent?.KEY33
                          : appContent.KEY32}
                      </Button>
                      <Button
                        disabled
                        sx={{
                          backgroundColor: "#DB0011",
                          color: "#fff",
                          padding: "0.2rem 0.4rem",
                          textTransform: "none",
                          borderRadius: "0.15rem",
                          ":hover": {
                            backgroundColor: "#DB0011",
                            color: "#fff",
                          },
                        }}
                        variant="contained"
                      >
                        {appContent?.KEY211}
                      </Button>
                    </Box>
                    {item?.isCancelled && (
                      <Box mt={"0.6rem"}>
                        <Typography
                          // variant="caption"
                          fontSize={"0.75rem"}
                        >
                          {item?.planType === subscriptionPlanType.Monthly
                            ? appContent?.KEY272
                            : appContent?.KEY273}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            ))}
          {subscriptionDetails?.length === 0 && (
            <Box
              borderRadius={"2px"}
              bgcolor={"#F3F3F3"}
              padding={"0.5rem 0rem"}
              boxShadow="0px 1px 4px 0px #00000040"
              mb={"0.8rem"}
            >
              <Box width={"90%"} margin={"auto"} textAlign={"center"}>
                <Typography
                  variant="h6"
                  fontSize={"1rem"}
                  color={"#183243"}
                  fontWeight={500}
                >
                  {appContent?.KEY268}
                </Typography>
              </Box>
              <Box
                width={"90%"}
                margin={"auto"}
                textAlign={"center"}
                mt={"0.5rem"}
              >
                <Box display={"flex"} gap={"0.4rem"} justifyContent={"center"}>
                  <Button
                    onClick={() => setActiveButton(0)}
                    sx={{
                      backgroundColor: "#DB0011",
                      color: "#fff",
                      padding: "0.2rem 0.4rem",
                      textTransform: "none",
                      borderRadius: "0.15rem",
                      ":hover": {
                        backgroundColor: "#DB0011",
                        color: "#fff",
                      },
                    }}
                    variant="contained"
                  >
                    {appContent?.KEY214}
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
        <Box width={"95%"}>
          {subscriptionDetails?.length > 0 &&
            subscriptionDetails[0]?.planType !== 0 && (
              <Box
                onClick={() => handleOpenManageMemeberDrawer()}
                sx={{ cursor: "pointer" }}
                padding={"0.8rem 0.8rem 0.8rem 0.5rem"}
                bgcolor={"#F3F3F3"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography>{appContent?.KEY222}</Typography>
                <Box>
                  <img src={right_arrow_icon} alt="icon" />
                </Box>
              </Box>
            )}

          {/* <Box
              sx={{ cursor: "pointer" }}
              padding={"0.8rem 0.8rem 0.8rem 0.5rem"}
              bgcolor={"#F3F3F3"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography>Payment History</Typography>
              <Box>
                <img src={right_arrow_icon} alt="icon" />
              </Box>
            </Box> */}

          <Box
            sx={{ cursor: "pointer" }}
            mt={"0.6rem"}
            mb={"0.6rem"}
            padding={"0.8rem 0.8rem 0.8rem 0.5rem"}
            bgcolor={"#F3F3F3"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            onClick={() => setBillingAddressOpen(true)}
          >
            <Typography>{appContent?.KEY223}</Typography>
            <Box>
              <img src={right_arrow_icon} alt="icon" />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ManageSubscriptionHome;
